export const teamDirectory = {
  contacts: [
    { name: 'QA Team Lead', role: 'Senior QA Engineer', email: 'qa-lead@company.com', slack: '@qa-lead' },
    { name: 'Test Automation Lead', role: 'Automation Architect', email: 'automation-lead@company.com', slack: '@automation-lead' },
    { name: 'Performance Testing Lead', role: 'Performance Engineer', email: 'perf-lead@company.com', slack: '@perf-lead' },
    { name: 'QA Product Manager', role: 'Product', email: 'qa-pm@company.com', slack: '@qa-pm' }
  ],
  mentors: [
    { name: 'Senior QA Mentor', expertise: 'Test Strategy & Quality Assurance', availability: 'Mon-Fri 2-4 PM' },
    { name: 'Automation Mentor', expertise: 'Test Automation & CI/CD Integration', availability: 'Tue/Thu 10 AM-12 PM' },
    { name: 'Performance Mentor', expertise: 'Performance & Load Testing', availability: 'Wed/Fri 3-5 PM' }
  ],
  collaborators: [
    { team: 'Development Teams', contact: 'dev-leads@company.com', purpose: 'Test Planning & Bug Resolution' },
    { team: 'Product Team', contact: 'product@company.com', purpose: 'Requirements & Acceptance Criteria' },
    { team: 'DevOps Team', contact: 'devops@company.com', purpose: 'Test Environment Management' },
    { team: 'Design Team', contact: 'design-lead@company.com', purpose: 'UI/UX Testing' }
  ],
  channels: {
    primary: '#qa-team',
    announcements: '#qa-announcements',
    help: '#qa-help',
    automation: '#test-automation',
    bugs: '#bug-reports',
    performance: '#performance-testing',
    releases: '#release-testing'
  }
};
